import { atom } from "jotai";

export const atomModalQuestionnaire = atom<boolean>( false );
export const atomModalSuccess = atom<boolean>( false );
export const atomModalFailure = atom( false );
export const atomModalContact = atom( false );
export const atomModalContactMessage = atom( false );